/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Feat3_TitleInputs */

const es_l6_feat3_title = /** @type {(inputs: L6_Feat3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más semanas ocupadas`)
};

const gl_l6_feat3_title = /** @type {(inputs: L6_Feat3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máis semanas ocupadas`)
};

const en_l6_feat3_title = /** @type {(inputs: L6_Feat3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More weeks booked`)
};

/**
* | output |
* | --- |
* | "More weeks booked" |
*
* @param {L6_Feat3_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_feat3_title = /** @type {((inputs?: L6_Feat3_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Feat3_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_feat3_title(inputs)
	if (locale === "en") return en_l6_feat3_title(inputs)
	return es_l6_feat3_title(inputs)
});